export default class AuthStatus {

    static CHECKING = "checking";
    static NOT_SIGNED_IN = "notSignedIn";
    static SIGNED_IN = "signedIn";


}